import AddOne from './add-one'

export default AddOne
